import React from 'react';
import PropTypes from 'prop-types';

const WebinarIcon = props => {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2773 13.5613H1.65234V14.6863H16.2773V13.5613Z" fill={props.color} />
      <path d="M0 12.7286H18V0H0V12.7286ZM1.125 1.125H16.875V11.6036H1.125V1.125Z" fill={props.color} />
      <path d="M6.95801 9.29647L12.028 6.36931L6.95801 3.44214V9.29647Z" fill={props.color} />
    </svg>
  );
};

WebinarIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default WebinarIcon;
